import { connect } from '@atlassian/jira-react-redux/src/index.tsx';
import { getComponentsPageRequest } from '../../state/actions.tsx';
import { getCurrentPage } from '../../state/query/selectors.tsx';
import type { State } from '../../state/reducer.tsx';
import { isLoading as isPageLoading } from '../../state/ui/page/selectors.tsx';
import ErrorView from './view.tsx';

const mapStateToProps = (state: State) => ({
	isLoading: isPageLoading(state),
	currentPage: getCurrentPage(state),
});

const mapDispatchToProps = {
	onRetry: getComponentsPageRequest,
} as const;

export default connect(mapStateToProps, mapDispatchToProps)(ErrorView);
